export default {
    install(Vue, options) {

        Vue.prototype.$formatPrice = function (p) {
            p = String(p);
            if(p.length == 0){
                p = '000';
            } else if(p.length == 1){
                p = '00'+p;
            } else if(p.length == 2){
                p = '0'+p;
            }
            return p.substr(0, (p.length - 2)) + ',' + p.substr((p.length - 2)) + '&euro;';
        }

        Vue.prototype.$normalizePrice = function (p) {
            p = String(p);
            return parseFloat(p.substr(0, (p.length - 2)) + '.' + p.substr((p.length - 2)));
        }

        Vue.prototype.$dbNormalizePrice = function (p) {
            p = String(p);
            var parsedVal = parseInt(parseFloat(p.replace(',','.')).toFixed(2).replace('.',''));
            if(isNaN(parsedVal)){
                parsedVal = 0;
            }
            return parsedVal;
        }

        Vue.prototype.$orderStatus = function (i) {
            var status;
            switch (parseInt(i)) {
                case -1:
                    status = 'aborted';
                    break;
                case 0:
                    status = 'inserted';
                    break;
                case 1:
                    status = 'accepted';
                    break;
                case 2:
                    status = 'payed';
                    break;
                case 3:
                    status = 'shipped';
                    break;
                default:
                    break;
            }
            return status;
        }

        Vue.prototype.$orderStatusColor = function (i) {
            var color;
            switch (parseInt(i)) {
                case -1:
                    color = 'danger';
                    break;
                case 0:
                    color = 'info';
                    break;
                case 1:
                    color = 'success';
                    break;
                case 2:
                    color = 'primary';
                    break;
                case 3:
                    color = 'secondary';
                    break;
                default:
                    break;
            }
            return color;
        }

        Vue.prototype.$productStatus = function (i) {
            var status;
            switch (parseInt(i)) {
                case 0:
                    status = 'draft';
                    break;
                case 1:
                    status = 'published';
                    break;
                default:
                    break;
            }
            return status;
        }

        Vue.prototype.$productStatusColor = function (i) {
            var color;
            switch (parseInt(i)) {
                case 0:
                    color = 'warning';
                    break;
                case 1:
                    color = 'success';
                    break;
            }
            return color;
        }
        Vue.prototype.$getAWSAssetUrl = function (url) {
            return url.replace('https://a.storyblok.com','https://api.apicolturaboni.it/imgprox');
        }
    }
  };